//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: [{ title: 'Date', filter: 'dateFull' }, { title: 'Number of Transactions' }, { title: 'Total Amount', filter: 'toCurrency' }, { title: 'User' }, { title: 'Status' }],
            fields: ['created_at', 'count', 'total', 'user.full_name', 'status'],
            items: [],
            isProcessing: false
        };
    },
    mounted: function mounted() {

        var $el = this;

        //$el.load()

        Event.$on('add-entry', function () {
            Event.$emit('add-ar-billing');
        });

        Event.$on('remove-entry', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/general-ledger/journal-entry/remove', 'delete-entry', 'Are you sure you want to delete this journal entry?', 'Delete');
        });

        Event.$on('delete-entry', function (item) {
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        });

        Event.$on('view-entry', function (item, idx) {
            Event.$emit('show-ar-billing', item);
        });

        Event.$on('refresh-billing-list', function () {
            Event.$emit('data-table-loading');
            $el.load();
        });
    },


    methods: {
        load: function load() {
            var _this = this;

            var $el = this;
            axios.get('/prototype/accounting/accounts-receivable/ar-billing-job').then(function (response) {
                $el.items = response.data;

                $el.items.map(function (item) {
                    return item.is_complete !== true ? _this.isProcessing = item.id : '';
                });

                Event.$emit('data-table-loaded');
            });
        }
    },

    watch: {
        isProcessing: function isProcessing(val) {
            var _this2 = this;

            var processingID = null;
            if (val !== false) {
                processingID = window.setInterval(function () {
                    _this2.items[0].status += '.';
                    axios.post('/prototype/accounting/accounts-receivable/billings/status', { job: _this2.isProcessing }).then(function (response) {
                        if (response.data === 1) {
                            _this2.isProcessing = false;
                            window.clearInterval(processingID);
                            _this2.items[0].status = 'Complete';
                        }
                    });
                }, 1000);
                console.log('processing');
            }
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/billings/ArBillingsList.vue
// module id = NsHs
// module chunks = 0 1